import DownloadWallpaperVue from '@/views/member/download-wallpaper/download-wallpaper.vue';

const basePath = '/member/download-wallpaper';
const role = 'member'; // 角色身份

export const M_DOWNLOAD_WALLPAPER_INDEX = 'm-download-wallpaper-index';
export const M_DOWNLOAD_WALLPAPER_INDEX_ANDROID = 'm-download-wallpaper-index-android';

export default {
    path: `${basePath}*`,
    redirect: `${basePath}/index`,
    component: DownloadWallpaperVue,
    meta: { requiresAuth: true },
    children: [{
        path: `${basePath}/index`,
        name: M_DOWNLOAD_WALLPAPER_INDEX,
        component: () =>
            import (
                /* webpackChunkName: "background-download" */
                `@/views/${role}/download-wallpaper/index.vue`
            ).catch(() =>
                import ('@/views/errors/404.vue')),
        meta: { requiresAuth: true }
    },
    {
        path: `${basePath}/index-android`,
        name: M_DOWNLOAD_WALLPAPER_INDEX_ANDROID,
        component: () =>
            import (
                /* webpackChunkName: "background-download" */
                `@/views/${role}/download-wallpaper/index-android.vue`
            ).catch(() =>
                import ('@/views/errors/404.vue')),
        meta: { requiresAuth: true }
    }, ]
};
